import React from "react";

export default function CustomEditInput({
  handleChange,
  name,
  placeholder,
  type,
  value,
}) {
  return (
    <div>
      <input
        className="mb-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
        id="inline-full-name"
        type={type === undefined ? "text" : type}
        name={name}
        onChange={handleChange}
        placeholder={placeholder}
        defaultValue={value}
      />
    </div>
  );
}
